






import { Component, Prop, Vue } from 'vue-property-decorator';
import Big from 'big.js';

@Component
export default class OfferBadge extends Vue {
  @Prop({required: false})
  private offerPercentage: Big | undefined;

  get offerPercentageString() {
    if (this.offerPercentage !== undefined) {
      return `-${this.offerPercentage.toString()}%`;
    }

    return '';
  }
}
